/*
  Warenkorb – Logik für Drawer und Warenkorbseite (snippets/cart-panel.liquid).
  Jede Änderung geht an die Ajax-API von Shopify und holt im selben Aufruf die neu
  gerenderten Sections (global-cart-drawer, main-cart), damit Drawer und Seite immer gleich sind.
  Öffnen des Drawers und "In den Warenkorb" auf Produktseiten: assets/theme.js
*/
(function () {
  'use strict';
  if (window.__mdlCart) return;
  window.__mdlCart = true;

  var DRAWER_SECTION = 'global-cart-drawer';
  var PAGE_SECTION = 'main-cart';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function track(name, params) { if (typeof window.mdlTrack === 'function') window.mdlTrack(name, params || {}); }

  function containers() {
    var list = [];
    var drawer = qs('#cart-drawer .cart-drawer-content');
    var page = qs('[data-mc-page]');
    if (drawer) list.push({ id: DRAWER_SECTION, el: drawer, sel: '.cart-drawer-content' });
    if (page) list.push({ id: PAGE_SECTION, el: page, sel: '[data-mc-page]' });
    return list;
  }

  /* ===== AJAX ===== */
  function post(url, body, withSections) {
    if (withSections !== false) {
      body.sections = containers().map(function (c) { return c.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error('cart');
          err.userMessage = data.description || data.message;
          throw err;
        }
        return data;
      });
    });
  }

  function refresh() {
    var ids = containers().map(function (c) { return c.id; });
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (res) { return res.json(); })
      .then(render)
      .catch(function () {});
  }

  /* ===== NEU RENDERN ===== */
  function render(sections) {
    if (!sections) return refresh();
    var active = document.activeElement;
    var focus = null;
    if (active && active.closest && active.closest('[data-mc-root]')) {
      var item = active.closest('[data-key]');
      focus = {
        key: item ? item.getAttribute('data-key') : null,
        action: active.getAttribute('data-mc-action'),
        inDrawer: !!active.closest('.cart-drawer-content')
      };
    }
    containers().forEach(function (c) {
      var html = sections[c.id];
      if (!html) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var fresh = qs(c.sel, temp);
      if (!fresh) return;
      var scroller = qs('[data-mc-scroll]', c.el) && qs('.mc-layout', c.el);
      var top = scroller ? scroller.scrollTop : 0;
      c.el.innerHTML = fresh.innerHTML;
      var newScroller = qs('.mc-layout', c.el);
      if (newScroller && top) newScroller.scrollTop = top;
    });
    if (toast && toast.el.isConnected === false) {
      /* Hinweis über das Neu-Rendern retten (z. B. wenn danach das Geschenk wegfällt) */
      var toastRoot = qs('[data-mc-root]', toast.scope);
      if (toastRoot) toastRoot.appendChild(toast.el);
    }
    if (focus) restoreFocus(focus);
    afterRender();
  }

  function restoreFocus(f) {
    var scope = f.inDrawer ? qs('.cart-drawer-content') : qs('[data-mc-page]');
    if (!scope) return;
    var target = null;
    if (f.key) {
      var item = qs('[data-key="' + f.key + '"]', scope);
      if (item) target = qs('[data-mc-action="' + f.action + '"]', item) || qs('[data-mc-action]', item);
    }
    if (!target) target = qs('.mc-qty__btn, [data-mc-close], .mc-cta', scope);
    if (target) target.focus({ preventScroll: true });
  }

  function afterRender() {
    updateBadge();
    initDelivery();
    initCountdown();
    initBar();
    checkGift();
  }

  /* ===== HEADER-ZÄHLER ===== */
  function updateBadge() {
    var root = qs('[data-mc-root]');
    var badge = document.getElementById('header-cart-drawer-item-count');
    if (!root || !badge) return;
    var count = parseInt(root.getAttribute('data-mc-count'), 10) || 0;
    badge.textContent = count;
    badge.classList.toggle('hide', count === 0);
    badge.setAttribute('aria-label', count + ' Artikel im Warenkorb');
  }

  /* ===== GESCHENK AB SCHWELLE AUTOMATISCH ===== */
  var giftBusy = false;
  var giftFailed = false;
  function checkGift() {
    var root = qs('[data-mc-root]');
    if (!root || giftBusy || giftFailed) return;
    var variant = root.getAttribute('data-gift-variant');
    var threshold = parseInt(root.getAttribute('data-gift-threshold'), 10) || 0;
    var key = root.getAttribute('data-gift-key');
    var subtotal = parseInt(root.getAttribute('data-subtotal'), 10) || 0;
    if (!variant || threshold <= 0) return;
    var qualifies = subtotal >= threshold;
    var request = null;
    if (qualifies && !key) {
      request = post('/cart/add.js', { items: [{ id: parseInt(variant, 10), quantity: 1, properties: { _gift: 'true' } }] });
    } else if (!qualifies && key) {
      request = post('/cart/change.js', { id: key, quantity: 0 });
    }
    if (!request) return;
    giftBusy = true;
    request
      .then(function (data) { giftBusy = false; render(data.sections); })
      .catch(function () { giftBusy = false; giftFailed = true; });
  }

  /* ===== LIEFERDATUM (Werktage Mo–Fr, wie auf der Produktseite) ===== */
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function addWorkdays(n) {
    var d = new Date(), added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    return d;
  }
  function fmtDay(d) { return DAYS[d.getDay()] + ', ' + d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  function initDelivery() {
    qsa('[data-mc-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10) || 0;
      if (days <= 0) return;
      el.textContent = days === 1 ? fmtDay(addWorkdays(1)) : fmtDay(addWorkdays(days - 1)) + ' – ' + fmtDay(addWorkdays(days));
    });
  }

  /* ===== VERSAND HEUTE: nur Mo–Fr vor der Uhrzeit, sonst ausgeblendet ===== */
  var countdownTimer = null;
  function initCountdown() {
    clearInterval(countdownTimer);
    var boxes = qsa('[data-mc-cutoff]');
    if (!boxes.length) return;
    function tick() {
      var now = new Date();
      boxes.forEach(function (box) {
        var hour = parseInt(box.getAttribute('data-mc-cutoff'), 10) || 14;
        var cutoff = new Date(now); cutoff.setHours(hour, 0, 0, 0);
        var day = now.getDay();
        var show = day !== 0 && day !== 6 && now < cutoff;
        box.hidden = !show;
        if (!show) return;
        var mins = Math.ceil((cutoff - now) / 60000);
        var h = Math.floor(mins / 60), m = mins % 60;
        var out = qs('[data-mc-countdown]', box);
        if (out) out.textContent = (h ? h + ' Std. ' : '') + m + ' Min.';
      });
    }
    tick();
    countdownTimer = setInterval(tick, 30000);
  }

  /* ===== WARENKORBSEITE: Leiste unten, sobald der Kassen-Button nicht sichtbar ist ===== */
  var barObserver = null;
  function initBar() {
    if (barObserver) { barObserver.disconnect(); barObserver = null; }
    var bar = qs('[data-mc-bar]');
    var cta = qs('[data-mc-cta-main]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    var link = qs('a', bar);
    barObserver = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (link) link.tabIndex = visible ? 0 : -1;
    });
    barObserver.observe(cta);
  }

  /* ===== HINWEIS MIT RÜCKGÄNGIG ===== */
  var toastTimer = null;
  var toast = null;
  function hideToast() {
    if (toast) toast.el.remove();
    toast = null;
  }
  function showToast(scope, text, undo) {
    var root = scope && qs('[data-mc-root]', scope);
    if (!root) return;
    hideToast();
    var el = document.createElement('div');
    el.className = 'mc-toast';
    el.setAttribute('role', 'status');
    var label = document.createElement('span');
    label.textContent = text;
    el.appendChild(label);
    if (undo) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'Rückgängig';
      btn.addEventListener('click', function () { hideToast(); undo(); });
      el.appendChild(btn);
    }
    root.appendChild(el);
    toast = { el: el, scope: scope };
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }

  /* ===== MENGE ÄNDERN / ENTFERNEN ===== */
  function itemError(item, message) {
    var el = qs('.mc-item__error', item);
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function changeLine(item, qty) {
    var scope = item.closest('.cart-drawer-content, [data-mc-page]');
    var removing = qty === 0;
    var variant = item.getAttribute('data-variant-id');
    var title = item.getAttribute('data-title') || 'Artikel';
    var valEl = qs('[data-qty]', item);
    var oldQty = valEl ? parseInt(valEl.getAttribute('data-qty'), 10) || 1 : 1;
    itemError(item, '');
    item.classList.add(removing ? 'is-removing' : 'is-updating');
    if (!removing && valEl) valEl.textContent = qty;
    return post('/cart/change.js', { id: item.getAttribute('data-key'), quantity: qty })
      .then(function (data) {
        render(data.sections);
        if (removing && variant) {
          showToast(scope, title + ' entfernt', function () {
            post('/cart/add.js', { items: [{ id: parseInt(variant, 10), quantity: oldQty }] })
              .then(function (d) { render(d.sections); })
              .catch(function () { refresh(); });
          });
        }
      })
      .catch(function (err) {
        item.classList.remove('is-updating', 'is-removing');
        if (valEl) valEl.textContent = oldQty;
        itemError(item, err.userMessage || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
      });
  }

  /* ===== RABATTCODES ===== */
  function appliedCodes(box) {
    return (box.getAttribute('data-applied') || '').split(',').filter(Boolean);
  }

  function applyCode(form) {
    var box = form.closest('.mc-code');
    var input = qs('.mc-code__input', form);
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var inDrawer = !!form.closest('.cart-drawer-content');
    var button = qs('.mc-code__apply', form);
    button.disabled = true;
    var codes = appliedCodes(box).concat(code);
    post('/cart/update.js', { discount: codes.join(',') })
      .then(function (data) {
        if (!Array.isArray(data.discount_codes)) {
          /* Ältere Shops: Code über die Rabatt-Adresse setzen */
          return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { return refresh().then(function () { return cart; }); });
        }
        render(data.sections);
        return data;
      })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (c) { return c.applicable && c.code.toUpperCase() === code.toUpperCase(); });
        track('Warenkorb_Rabattcode', { Code: code.toUpperCase(), Erfolg: ok ? 'Ja' : 'Nein' });
        if (ok) return;
        var scope = inDrawer ? qs('.cart-drawer-content') : qs('[data-mc-page]');
        var newBox = scope && qs('.mc-code', scope);
        if (!newBox) return;
        var newForm = qs('[data-mc-code-form]', newBox);
        var toggle = qs('.mc-code__toggle', newBox);
        var err = qs('.mc-code__error', newBox);
        newForm.hidden = false;
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        qs('.mc-code__input', newForm).value = code;
        err.textContent = '„' + code + '“ passt leider nicht zu deinem Warenkorb. Schau nochmal, ob der Code richtig geschrieben ist.';
        err.hidden = false;
      })
      .catch(function () {
        button.disabled = false;
        var err = qs('.mc-code__error', box);
        err.textContent = 'Der Code konnte gerade nicht geprüft werden. Bitte versuch es noch einmal.';
        err.hidden = false;
      });
  }

  function removeCode(button) {
    var box = button.closest('.mc-code');
    var code = button.getAttribute('data-code');
    var rest = appliedCodes(box).filter(function (c) { return c !== code; });
    button.disabled = true;
    post('/cart/update.js', { discount: rest.join(',') })
      .then(function (data) { render(data.sections); })
      .catch(function () { button.disabled = false; });
  }

  /* ===== BESTELLNOTIZ ===== */
  var noteTimer = null;
  var notePending = null;
  function saveNote(input) {
    var status = qs('.mc-note__status', input.parentElement);
    if (status) status.textContent = 'Wird gespeichert …';
    return post('/cart/update.js', { note: input.value }, false)
      .then(function () { if (status) status.textContent = 'Gespeichert'; })
      .catch(function () { if (status) status.textContent = 'Konnte nicht gespeichert werden.'; });
  }

  /* ===== DRAWER SCHLIESSEN ===== */
  var hideTimer = null;
  function drawerIsOpen() {
    var drawer = qs('#cart-drawer');
    return !!(drawer && drawer.classList.contains('is-open'));
  }
  function closeDrawer() {
    var drawer = qs('#cart-drawer');
    if (!drawer) return;
    var content = qs('.cart-drawer-content', drawer);
    var overlay = qs('#cart-drawer-overlay');
    var hadFocus = content && content.contains(document.activeElement);
    drawer.classList.remove('is-open');
    if (overlay) { overlay.style.opacity = '0'; overlay.style.pointerEvents = 'none'; }
    if (content) { content.classList.remove('is-open'); content.style.transform = ''; }
    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.style.visibility = 'hidden'; }, 400);
    var icon = qs('.header-menu-cart-drawer');
    if (icon && hadFocus) icon.focus({ preventScroll: true });
  }

  /* ===== KLICKS ===== */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-mc-close]') || t.id === 'cart-drawer-overlay') { e.preventDefault(); closeDrawer(); return; }

    var checkout = t.closest('[data-mc-checkout]');
    if (checkout) {
      if (notePending) {
        e.preventDefault();
        clearTimeout(noteTimer);
        var input = notePending; notePending = null;
        saveNote(input).then(function () { window.location.href = checkout.href; });
      }
      checkout.classList.add('is-busy');
      return;
    }

    var btn = t.closest('[data-mc-action]');
    if (!btn || !btn.closest('[data-mc-root]')) return;
    var action = btn.getAttribute('data-mc-action');
    var item = btn.closest('.mc-item');
    e.preventDefault();

    if (action === 'plus' || action === 'minus') {
      var val = qs('[data-qty]', item);
      var q = (parseInt(val && val.getAttribute('data-qty'), 10) || 1) + (action === 'plus' ? 1 : -1);
      changeLine(item, Math.max(0, q));
    } else if (action === 'remove') {
      changeLine(item, 0);
    } else if (action === 'add') {
      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) return;
      btn.classList.add('is-busy');
      var card = btn.closest('.mc-up__card');
      var name = card ? (qs('.mc-up__name', card) || {}).textContent : '';
      post('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function (data) {
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          track('Warenkorb_Zusatz', { Artikel: (name || '').trim(), Variante: String(id) });
          setTimeout(function () { render(data.sections); }, 350);
        })
        .catch(function (err) {
          btn.classList.remove('is-busy');
          var scope = btn.closest('.cart-drawer-content, [data-mc-page]');
          showToast(scope, err.userMessage || 'Konnte nicht hinzugefügt werden.');
        });
    } else if (action === 'code-toggle' || action === 'note-toggle') {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = action === 'code-toggle' ? qs('[data-mc-code-form]', btn.parentElement) : btn.nextElementSibling;
      if (!panel) return;
      panel.hidden = open;
      if (!open) { var field = qs('input, textarea', panel); if (field) field.focus(); }
    } else if (action === 'code-remove') {
      removeCode(btn);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-mc-code-form]');
    if (!form) return;
    e.preventDefault();
    applyCode(form);
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('mc-code__input')) {
      var err = qs('.mc-code__error', t.closest('.mc-code'));
      if (err) err.hidden = true;
      return;
    }
    if (!t.classList || !t.classList.contains('mc-note__input')) return;
    notePending = t;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { notePending = null; saveNote(t); }, 600);
  });

  /* Esc schließt, Tab bleibt im geöffneten Drawer */
  document.addEventListener('keydown', function (e) {
    if (!drawerIsOpen()) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var content = qs('.cart-drawer-content');
    if (!content) return;
    var focusables = qsa('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', content)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (!content.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* iOS: Wischen auf Kopf und Kassen-Leiste soll die Seite dahinter nicht scrollen */
  document.addEventListener('touchmove', function (e) {
    if (!drawerIsOpen() || !e.target.closest) return;
    if (e.target.closest('.cart-drawer-content') && !e.target.closest('.mc-layout, .mc-empty, textarea')) e.preventDefault();
  }, { passive: false });

  /* Zurück-Taste aus der Kasse: Button wieder freigeben, Warenkorb auffrischen */
  window.addEventListener('pageshow', function (e) {
    qsa('[data-mc-checkout].is-busy').forEach(function (b) { b.classList.remove('is-busy'); });
    if (e.persisted) refresh();
  });

  /* theme.js tauscht den Drawer-Inhalt nach "In den Warenkorb" aus */
  document.addEventListener('cart:updated', function () {
    if (qs('[data-mc-page]')) refresh(); else afterRender();
  });

  afterRender();
})();
